import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Safe serialization helper that handles Date objects, undefined values, and circular references
 * Converts data to a format safe for passing to client components
 */
export function safeSerialize<T>(data: T): T {
  try {
    // Handle null/undefined
    if (data === null || data === undefined) {
      return data;
    }

    // Handle Date objects
    if (data instanceof Date) {
      return data.toISOString() as unknown as T;
    }

    // Handle arrays
    if (Array.isArray(data)) {
      return data.map(item => safeSerialize(item)) as unknown as T;
    }

    // Handle objects
    if (typeof data === 'object') {
      const serialized: any = {};
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const value = (data as any)[key];
          // Skip functions
          if (typeof value === 'function') {
            continue;
          }
          // Handle Date objects
          if (value instanceof Date) {
            serialized[key] = value.toISOString();
          } else {
            serialized[key] = safeSerialize(value);
          }
        }
      }
      return serialized as T;
    }

    // Primitive values pass through
    return data;
  } catch (error) {
    console.error('[safeSerialize] Error serializing data:', error);
    // Fallback to JSON.parse(JSON.stringify()) if custom serialization fails
    try {
      return JSON.parse(JSON.stringify(data));
    } catch (fallbackError) {
      console.error('[safeSerialize] Fallback serialization also failed:', fallbackError);
      return data;
    }
  }
}






